// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content013_wrapper__aYwtb","title":"Content013_title__XK9Tz","icon":"Content013_icon__vo2__","arrow":"Content013_arrow__hSvwa","link":"Content013_link__UcaID"};